import React, { useEffect, useState } from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useMedia } from 'use-media';

const Sentence = (props) => {
  const isPC = useMedia({ minWidth: '1000px' });
  const [displayContens, setDisplayContens] = useState();
  let tmpArr;

  useEffect(() => {
    if (!props.activeWord && props.sentence) {
      setDisplayContens(props.sentence.completed_english_sentence);
    }
  }, [props.sentence, props.activeWord]);

  let sentenceStyle;
  if (isPC) {
    sentenceStyle = css`
    div {
        width: auto;
        margin: 0 0 1em 0;
        background: #f4f4f4;
        border-left: solid 6px #5bb7ae;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.33);
        font-family: 'Exo 2';
        font-size: 1.8em;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 30px;


        background-color:rgba(86, 185, 255, 0.2);
    }
  `;
  } else {
    sentenceStyle = css`
    div {
        width: auto;
        margin-bottom: 0.5em;
        background: #f4f4f4;
        border-left: solid 6px #5bb7ae;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.33);
        font-family: 'Exo 2';
        font-size: 1em;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;


        background-color:rgba(86, 185, 255, 0.2);
    }
  `;
  }
  return (
    <>
      <div css={sentenceStyle}>
        <div>
          {displayContens}
        </div>
      </div>
    </>
  )
}

export default Sentence
